import { FormEvent, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Company } from '@kanda-libs/ks-frontend-services';

import useSearchQuery from 'hooks/useSearchQuery';
import { selectors } from 'store';

import { SEARCH_OPTIONS } from './constants';

export interface CidLookupHook {
  searchTerm: string;
  results: Company[];
  cid: string;
  setCid: (cid: string) => void;
  company?: Company;
  onChange: (e: FormEvent<HTMLInputElement>) => void;
  onFocus: () => void;
}

export default function useCidLookup(
  onChangeValue: (cid?: string) => void,
): CidLookupHook {
  const companies = useSelector(selectors.company.getEntitiesAsArray);
  const companiesById = useSelector(selectors.company.getEntities);

  const [searchTerm, setSearchTerm] = useState('');
  const [cid, setCid] = useState('');

  const { hits, setQuery } = useSearchQuery(
    companies,
    'companies',
    SEARCH_OPTIONS,
  );

  const company = companiesById[cid];

  useEffect(() => {
    setQuery(searchTerm);
  }, [searchTerm]);

  const onChange = (e: FormEvent<HTMLInputElement>) => {
    console.log(e.currentTarget.value);
    setSearchTerm(e.currentTarget.value);
  };

  const onFocus = useCallback(() => {
    if (cid) {
      setSearchTerm('');
      setCid('');
      onChangeValue('');
    }
  }, [cid]);

  return {
    searchTerm,
    results: hits.map(({ item }) => item),
    cid,
    setCid,
    company,
    onChange,
    onFocus,
  };
}
